import { Container, Modal } from "react-bootstrap";
import Close from "../../Assets/close.svg";

const CustomModal = ({
  showModal = true,
  children,
  setShowModal,
  title,
  isDismissible = true,
  size = 'sm',
  rootClassName='default'
}) => {
  const handleHide = () => {
    if (isDismissible) {
      setShowModal(false);
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => handleHide()}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-size"
        className={rootClassName}
      >
        {title && (
          <Modal.Header style={{borderBottom:"1px solid #313131"}}>
            <Modal.Title>
              <div>
                <span
                  role="title"
                  className="text-white"
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  {title}
                </span>
              </div>
            </Modal.Title>
            <img
              onClick={() => setShowModal(false)}
              style={{ marginTop: "15px",marginRight: "5px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              role="close"
              data-testid="close"
              className="cursor-pointer"
            />
          </Modal.Header>
        )}
        <Modal.Body role="root">{children}</Modal.Body>
      </Modal>
    </>
  );
};

export default CustomModal;
